import React, { type ReactNode } from 'react';
import Breadcrumb from '@atlassian/jira-breadcrumbs/src/breadcrumb/component.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import messages from './messages.tsx';

type Props = {
	projectKey: string | undefined;
	children: ReactNode;
};

export const KnowledgeBaseBreadcrumb = ({ projectKey, children }: Props) => {
	const { formatMessage } = useIntl();
	const constructHref = () =>
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		getWillShowNav4() && window.location.href.includes('/categories')
			? `/jira/servicedesk/projects/${projectKey}/knowledge/categories`
			: `/jira/servicedesk/projects/${projectKey}/knowledge`;

	return (
		<Breadcrumb
			breadcrumb={{
				href: constructHref(),
				text: formatMessage(messages.knowledgeBase),
				type: 'jsd-knowledge-base',
			}}
		>
			{children}
		</Breadcrumb>
	);
};

export default KnowledgeBaseBreadcrumb;
